import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../services/AuthService' 

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  constructor(private aut:AuthService) { }

  ngOnInit() {
    let testUser;
    //this.aut.listAllUsers();
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/user/user.component.ts